module.exports = __webpack_public_path__ + "img/ab-testing.ac30b408.svg";